import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNil, always, pipe, ifElse, cond, equals, not, or, and } from 'ramda';
import moment from 'moment';

import { Container, Row } from './cancellationPolicy.styles';
import messages from './cancellationPolicy.messages';
import { mapPolicy } from '../../utils/policy';

const ROW_TYPE_START = 'start';
const ROW_TYPE_MIDDLE = 'middle';
const ROW_TYPE_END = 'end';

const ZERO_REFUND_VALUE = '0%';

const isStartRowType = equals(ROW_TYPE_START);
const isMiddleRowType = equals(ROW_TYPE_MIDDLE);
const isEndRowType = equals(ROW_TYPE_END);

const isMiddleRow = props => not(or(isNil(props.lessThan), isNil(props.moreThan)));
const isStartRow = props => or(not(isNil(props.moreThan)), and(isNil(props.moreThan), isNil(props.lessThan)));
const isEndRow = props => not(isNil(props.lessThan));

export class CancellationPolicy extends PureComponent {
  static propTypes = {
    refund: PropTypes.object.isRequired,
    intl: PropTypes.object,
  };

  getFormattedPeriodHours = pipe(
    hours => moment.duration(parseInt(hours, 10), 'hours').asHours(),
    count => this.props.intl.formatMessage(messages.hours, { count })
  );

  getRowType = cond([
    [isMiddleRow, always(ROW_TYPE_MIDDLE)],
    [isStartRow, always(ROW_TYPE_START)],
    [isEndRow, always(ROW_TYPE_END)],
  ]);

  rowText = row => {
    const { moreThan, lessThan, refund } = row;
    const { formatMessage } = this.props.intl;

    const lessThanDuration = this.getFormattedPeriodHours(lessThan);
    const moreThanDuration = this.getFormattedPeriodHours(moreThan);

    return cond([
      [isMiddleRowType, always(formatMessage(messages.middleRow, { moreThanDuration, lessThanDuration, refund }))],
      [
        isStartRowType,
        () =>
          ifElse(
            isNil,
            always(formatMessage(messages.startRowWithoutDuration, { refund })),
            always(formatMessage(messages.startRow, { moreThanDuration, refund }))
          )(moreThan),
      ],
      [
        isEndRowType,
        () =>
          ifElse(
            equals(ZERO_REFUND_VALUE),
            always(formatMessage(messages.endRow, { lessThanDuration })),
            always(formatMessage(messages.endRowWithRefund, { lessThanDuration, refund }))
          )(refund),
      ],
    ])(this.getRowType(row));
  };

  render() {
    const { refund } = this.props;

    return (
      <Container>
        {mapPolicy(refund).map((row, index) => (
          <Row key={index}>{this.rowText(row)}</Row>
        ))}
      </Container>
    );
  }
}
